import React from "react";
import {DEFAULT_LOCALE, LOCALES_HELPER} from "../../../../locales/config";
import img1en from "./imgs/MC1.jpeg";


export function MC1() {

    const lang = LOCALES_HELPER.getLan();
    return (
        <>
            {lang === DEFAULT_LOCALE
                ? <>
                    
                </>
                : <>
                    <img className="product-img" src={img1en}/>
                </>
            }
        </>
    )
}